module.exports = __webpack_public_path__ + "resource/img/image007.8de0dabc.png";